<app-header [headerTitle]="headerTitle"></app-header>
<div class="main-wrapper" tabindex="1" [hidden]="isDisplayCityMap">
  <div class="main-inner-wrapper">
    <!-- viewing the world map while the character is inside a city -->
    <div class="mv-notice" *ngIf="displayHeader" role="status">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8" />
        <path d="M12 11v5M12 7.5h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      <span><strong>Viewing only.</strong> Your token is inside a city, so it can't be moved on this map.</span>
      <button type="button" class="btn btn-dark btn-sm" (click)="continuePlaying()">{{ isPlaying ? 'Continue playing' : 'Visit city' }}</button>
    </div>

    <div *ngIf="isMenu2Open" [ngClass]="{ 'side-menu': isMenu2Open, 'margin-200': isMenu1Open }">
      <button class="btn-first-close" (click)="toggleMenu('menu2', false)">
        <i class="fa fa-close"></i>
      </button>
      <div class="content-div" [ngSwitch]="optionText">
        <div class="saved-content-div" *ngSwitchCase="'Saved'">
        </div>
        <div class="history-main-wrapper" *ngSwitchCase="'playerHistory'">
          <h6 class="text-center menu-option btn-option" style="color: white">
            {{ "Player History" }}
          </h6>
          <div class="history-inner-wrapper p-2">
            <div class="history-records-wrapper border border-secondary mb-1 myStylePlayer"
              *ngFor="let record of historyRecords; let i = index">
              <div class="d-flex align-items-start justify-content-start flex-column mb-2"
                (click)="historyRecordSelected(i, historyRecords)">
                <div class="story-wrapper d-flex flex-wrap">
                  <p class="m-0">{{ record.details }}</p>
                </div>
                <div class="button-wrapper align-self-end justify-content-end">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                    (click)="editDetail(record, false)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M10.5137 0.806497C11.5869 -0.268258 13.3274 -0.268916 14.4013 0.805026L16.8932 3.29688C17.958 4.36166 17.969 6.08542 16.918 7.16379L7.68486 16.637C6.97933 17.3609 6.01167 17.7691 5.00124 17.7691L2.24909 17.7689C0.969844 17.7689 -0.0517699 16.7025 0.00203171 15.4234L0.120186 12.6144C0.159684 11.6754 0.549963 10.7854 1.2138 10.1205L10.5137 0.806497ZM13.3415 1.86649C12.8533 1.37833 12.0622 1.37863 11.5744 1.86716L9.9113 3.53276L14.1911 7.81255L15.8446 6.11603C16.3224 5.62586 16.3173 4.84233 15.8333 4.35834L13.3415 1.86649ZM2.27446 11.1812L8.85145 4.59422L13.144 8.88682L6.61148 15.5893C6.18816 16.0236 5.60756 16.2685 5.0013 16.2685L2.24916 16.2684C1.82274 16.2684 1.4822 15.9129 1.50014 15.4865L1.61829 12.6775C1.64199 12.1141 1.87616 11.5801 2.27446 11.1812ZM17.5148 17.6958C17.9289 17.6958 18.2645 17.3598 18.2645 16.9455C18.2645 16.5311 17.9289 16.1952 17.5148 16.1952H11.3931C10.9791 16.1952 10.6434 16.5311 10.6434 16.9455C10.6434 17.3598 10.9791 17.6958 11.3931 17.6958H17.5148Z"
                      fill="#fff" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-wrapper-create-content mt-5" *ngSwitchCase="'createContent'">
          <div class="content-list-wrapper">
            <ng--container *ngFor="let content of contentCreatorData; let i = index">
              <div class="content-inner">
                <h5>{{ content.content_title }}</h5>
                <div class="d-flex align-items-center justify-content-center">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                    (click)="editRecord(content)" class="mr-2 pointer">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M10.5137 0.806497C11.5869 -0.268258 13.3274 -0.268916 14.4013 0.805026L16.8932 3.29688C17.958 4.36166 17.969 6.08542 16.918 7.16379L7.68486 16.637C6.97933 17.3609 6.01167 17.7691 5.00124 17.7691L2.24909 17.7689C0.969844 17.7689 -0.0517699 16.7025 0.00203171 15.4234L0.120186 12.6144C0.159684 11.6754 0.549963 10.7854 1.2138 10.1205L10.5137 0.806497ZM13.3415 1.86649C12.8533 1.37833 12.0622 1.37863 11.5744 1.86716L9.9113 3.53276L14.1911 7.81255L15.8446 6.11603C16.3224 5.62586 16.3173 4.84233 15.8333 4.35834L13.3415 1.86649ZM2.27446 11.1812L8.85145 4.59422L13.144 8.88682L6.61148 15.5893C6.18816 16.0236 5.60756 16.2685 5.0013 16.2685L2.24916 16.2684C1.82274 16.2684 1.4822 15.9129 1.50014 15.4865L1.61829 12.6775C1.64199 12.1141 1.87616 11.5801 2.27446 11.1812ZM17.5148 17.6958C17.9289 17.6958 18.2645 17.3598 18.2645 16.9455C18.2645 16.5311 17.9289 16.1952 17.5148 16.1952H11.3931C10.9791 16.1952 10.6434 16.5311 10.6434 16.9455C10.6434 17.3598 10.9791 17.6958 11.3931 17.6958H17.5148Z"
                      fill="#fff" />
                  </svg>
                  <button type="button " class="delete-btn" (click)="deleteRecord(content.id)">
                    <i class="fa fa-trash"> </i>
                  </button>
                </div>
              </div>
            </ng--container>
          </div>
        </div>
        <div class="main-wrapper-create-content mt-5" *ngSwitchCase="'playersContent'">
          <div class="content-list-wrapper">
            <ng--container *ngFor="let content of playerCreatorData; let i = index">
              <div class="content-inner">
                <h5>{{ content.content_title }}</h5>
              </div>
            </ng--container>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-around flex-column" *ngSwitchCase="'favorites'">
          <div
            class="saved-item-div d-flex align-items-center justify-content-around border border-dark p-1 secondPanel favroite-main-div"
            *ngFor="let favroiteItem of favroiteRecords; let i = index">
          </div>
        </div>
        <div style="color: #fff" *ngSwitchDefaults>Render this</div>
      </div>
    </div>
  </div>
  <div class="mapWrap game-master-map" [style.marginLeft]="isMenu2Open ? '400px' : isMenu1Open ? '200px' : '0px'"
    (contextmenu)="onRightClickPopup($event)" style="width: calc(auto - 400px); background-color: white" id="map" #map
    [ngStyle]="{ height: windowmapheight }"></div>

  <!-- right-click menu: what to do at this spot -->
  <div class="map-ctx" *ngIf="showMenu" [style.top.px]="menuPosition.y" [style.left.px]="menuPosition.x" role="menu">
    <div class="map-ctx-head">
      <span>At this spot</span>
      <button type="button" class="map-ctx-close" (click)="showMenu = false" aria-label="Close"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>
    </div>
    <button type="button" class="map-ctx-item" role="menuitem" (click)="createContent()" [disabled]="isLoading"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span>Create new content</span><i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i></button>
    <button type="button" class="map-ctx-item" role="menuitem" (click)="browseWpStore()" [disabled]="isLoading"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M4 9h16l-1.2 10.2a1 1 0 0 1-1 .8H6.2a1 1 0 0 1-1-.8L4 9Zm4 0V7a4 4 0 0 1 8 0v2" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg><span>Browse store content</span></button>
    <button type="button" class="map-ctx-item" role="menuitem" (click)="openPlaceContentModal()" [disabled]="isLoading"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M4 7h16v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7Zm-1-3h18v3H3V4Zm6 7h6" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/></svg><span>Add from your vault</span></button>
  </div>

  <div class="map-top-header">
    <div class="dmenu">
      <img src="assets/icons/down-arrow-white.svg" alt="" (click)="openSideDropdownOption()" />
      <ul class="dropdown-options" *ngIf="showDropdown">
        <li (click)="setSelectOption('Favourite')">
          Favorites<svg _ngcontent-cmp-c112="" width="10" height="17" viewBox="0 0 10 17" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path _ngcontent-cmp-c112="" d="M1.39062 1.41052L8.39062 8.41052L1.39062 15.4105" stroke="white"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </li>
        <li (click)="setSelectOption('Journal')">
          Journal<svg _ngcontent-cmp-c112="" width="10" height="17" viewBox="0 0 10 17" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path _ngcontent-cmp-c112="" d="M1.39062 1.41052L8.39062 8.41052L1.39062 15.4105" stroke="white"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </li>
      </ul>
      <div class="parent-container" [ngSwitch]="selectedOption">
        <ng-container *ngIf="showItemDetailsBox">
          <div class="favorites-modal" *ngSwitchCase="'Favourite'">
            <div class="header mb-2">
              <h4>Favorites</h4>
              <button class="close-button" (click)="closeSecondMenu()">
                <img src="assets/icons/icon-close.svg" alt="" />
              </button>
            </div>
            <div class="favorites-body" *ngIf="
                favroiteRecords && favroiteRecords.length > 0;
                else noFavroiteRecords
              ">
              <div class="form-check-box" *ngFor="let record of favroiteRecords; let i = index">
                <div class="form-check-b">
                  <input type="checkbox" value="" id="cb{{ i }}" />
                  <label>{{ record.title }}</label>
                </div>
                <span *ngIf="isRemovingFavorite !== record.wp_content_usage_id">
                  <img src="assets/icons/icon-close.svg" alt="" (click)="removeFromFavroite(record)"
                    style="cursor:pointer;" />
                </span>
                <span *ngIf="isRemovingFavorite === record.wp_content_usage_id">
                  <div class="spinner-border spinner-border-sm text-light" role="status"></div>
                </span>
              </div>
            </div>
            <ng-template #noFavroiteRecords>
              <p class="text-center text-white">No favorite records found.</p>
            </ng-template>
          </div>

          <div class="favorites-modal" *ngSwitchCase="'Journal'">
            <div class="header">
              <h4>JOURNAL</h4>
              <button class="close-button">
                <img src="assets/icons/icon-close.svg" alt="" (click)="closeSecondMenu()" />
              </button>
            </div>
            <div class="favorites-body history-body" *ngIf="
                historyRecords && historyRecords.length > 0;
                else noJournalRecords
              ">
              <ng-container *ngFor="let journalEntry of historyRecords; let i = index">
                <!-- Parent Entry -->
                <div class="form-check-box">
                  <div class="form-check-b">
                    <input type="checkbox" id="cb{{ i }}" [value]="journalEntry.id" [(ngModel)]="journalEntry.selected"
                      (change)="journalCheckBoxChange($event, i)" />

                    <div class="title-row">
                      <label (click)="
                          journalEntry.expanded = !journalEntry.expanded;
                          $event.stopPropagation()
                        ">
                        {{ journalEntry.title }}</label>

                      <!-- Expand arrow -->
                      <svg *ngIf="journalEntry.children?.length" class="expand-svg"
                        (click)="journalEntry.expanded = !journalEntry.expanded"
                        [ngClass]="{ rotated: journalEntry.expanded }" width="12" height="12" viewBox="0 0 24 24"
                        fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 8px">
                        <path d="M8 5L15 12L8 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>

                      <!-- Edit icon -->
                      <img class="edit-icon" src="assets/icons/icon-edit-white.svg" (click)="
                          editDetail(journalEntry, false);
                          $event.stopPropagation()
                        " />
                    </div>
                  </div>
                </div>

                <!-- Child Entries -->
                <div class="child-entry-box" *ngIf="journalEntry.expanded">
                  <div class="form-check-box child-entry" *ngFor="let child of journalEntry.children; let ci = index"
                    (click)="historyRecordSelected(ci, journalEntry.children)">
                    <div class="form-check-b">
                      <label>{{ child.title }}</label>
                      <span>
                        <img src="assets/icons/icon-edit-white.svg" alt="" (click)="
                            editDetail(child, true); $event.stopPropagation()
                          " />
                      </span>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

            <ng-template #noJournalRecords>
              <p class="text-center text-white">No journal records found.</p>
            </ng-template>
          </div>

          <div class="gmtool-modal" *ngSwitchCase="'GMTools'">
            <div class="header">
              <h4>Game Master Tools</h4>
              <button class="close-button" (click)="closeSecondMenu()">
                <img src="assets/icons/icon-close.svg" alt="" />
              </button>
            </div>
            <div class="gmtool-body">
              <p (click)="openNoteModal(false)" class="pointer">
                GAME MASTER NOTES
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- map search is not built yet; the box stays hidden until it is -->

    <div class="bgtngrops">
      <div class="btn-group-toggle" data-toggle="buttons" *ngFor="let btn of filterlayers(layerlist)">
        <label class="btn headbtn" [attr.title]="btn.label?.toLowerCase() === 'zones' ? 'Zones are always shown' : null" [ngClass]="[
            btn.checked ? 'active ' : '',
            btn.label?.toLowerCase() === 'zones'
              ? 'disabled btn-grey active'
              : 'btn-secondary',
          ]">
          <input type="checkbox" [checked]="btn.checked" (change)="changeToggleLayer(btn)"
            [disabled]="btn.label?.toLowerCase() === 'zones'" />
          {{ btn.label }}
        </label>
      </div>
    </div>

    <div class="mv-right">
      <button type="button" class="btn btn-dark mv-back" [routerLink]="['/char-portfolio']">Back</button>
      <div class="btn-map-icon">
          <button type="button" class="btnmap" (click)="triggerTokenZoom()" title="Go to the party token" aria-label="Go to the party token">
            <img src="assets/icons/icon-map-location.svg" alt="" />
          </button>
        <button type="button" class="btnmap" (click)="triggerZoomIn()" title="Zoom in" aria-label="Zoom in">
          <img src="assets/icons/icon-map-plus.svg" alt="" />
        </button>
        <button type="button" class="btnmap" (click)="triggerZoomOut()" title="Zoom out" aria-label="Zoom out">
          <img src="assets/icons/icon-map-minus.svg" alt="" />
        </button>
      </div>
    </div>
  </div>

  <div class="color-btn-box">
    <h4 (click)="toggleCultureList()" *ngIf="currentLayerName">
      {{ currentLayerName
      }}{{
      currentLayerName.toLowerCase() === "state" ||
      currentLayerName.toLowerCase() === "culture"
      ? "s"
      : ""
      }}
      <i class="fa" [ngClass]="isCultureVisible ? 'fa-angle-down' : 'fa-angle-up'"
        style="margin-left: auto; color: #fff"></i>
    </h4>

    <ng-container *ngIf="isCultureVisible">
      <!-- If currentLayerName is 'heightmap', show static image -->
      <div *ngIf="currentLayerName === 'heightmap'; else showLegend">
        <div class="d-flex flex-column align-items-center justify-content-center g-10">
          <img src="assets/images/heightmap-legend.png" alt="Heightmap Legend" style="width: 100%; padding: 10px" />
          <p class="height-text" (click)="navigateToElevationLink()">
            ELEVATIONS &#40;Feet&#41;
          </p>
        </div>
      </div>

      <!-- Fallback to normal legend display -->
      <ng-template #showLegend>
        <ul *ngIf="legendData && legendData.length > 0; else noData">
          <li *ngFor="let data of legendData" (click)="onDynamicDataClick(data.full_name || data.name)" class="">
            <span [ngStyle]="{ 'background-color': data.color }"></span>
            <div class="pointer pointer-cursor-link custom-width-color-btn">
              {{ data.name }}
            </div>
          </li>
        </ul>
        <ng-template #noData>
          <p style="color: white; padding-left: 10px">No data available</p>
        </ng-template>
      </ng-template>
    </ng-container>
  </div>

  <div class="mapdetail-box" [class.open]="sideInfoBar" [class.hidden]="!sideInfoBar" #sideContent>
    <h4 class="mapdetail-header" (click)="toggleMapDetails()">
      MAP DETAILS
      <i class="fa" [ngClass]="isMapDetailsVisible ? 'fa-angle-down' : 'fa-angle-up'" style="margin-left: auto"></i>
    </h4>

    <ul *ngIf="isMapDetailsVisible">
      <li *ngIf="map_name">
        World:&nbsp;
        <span class="pointer pointer-cursor-link pl-2" (click)="navigateToWikiWorld(map_name)">{{
          map_name ||
          "Unnamed
          Map"
          }}</span>
      </li>
      <ng-container *ngIf="objectData; else elseBlockNoData">
        <ng-container *ngFor="let property of objectData | keyvalue: cellDetailsSort">
          <ng-container *ngIf="property.key !== 'id' && property.key !== 'burgs_data'">
            <li [class.bdr-top]="
                property.key === 'State' || property.key === 'Natural Resources'
              ">
              {{ property.key }}:&nbsp;

              <!-- Render resources as links if applicable -->
              <ng-container *ngIf="isResourceField(property.key); else normalLink">
                <ng-container *ngIf="splitResources(property.value)?.length > 0; else None">
                  <ng-container *ngFor="
                      let item of splitResources(property.value);
                      let i = index
                    ">
                    <div href="#" class="pointer pointer-cursor-link pl-2"
                      (click)="onResourceClick(item.name || item)"
                      (mouseenter)="showResourceTooltip($event, item)"
                      (mouseleave)="hideResourceTooltip()">
                      {{ item.name || item }}
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #None>
                  <span> None</span>
                </ng-template>
              </ng-container>

              <!-- Fallback: normal value -->
              <ng-template #normalLink>
                <ng-container *ngIf="isLinkField(property.key); else normalValue">
                  <ng-container *ngIf="property?.value; else noValue">
                    <div class="pointer pointer-cursor-link pl-2" (click)="
                        navigateToDynamicLink(property.key, property.value)
                      ">
                      {{ property.value }}
                    </div>
                  </ng-container>
                  <ng-template #noValue>
                    <span>None</span>
                  </ng-template>
                </ng-container>
              </ng-template>
              <ng-template #normalValue>
                <span> {{ property.value }}</span>
              </ng-template>
            </li>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #elseBlockNoData>
        <li>No cell selected</li>
      </ng-template>
    </ul>
  </div>
  <div class="city-detail-box" [class.open]="isCityDetailsVisible" #sideContent>
    <h4 (click)="toggleCityMapDetails()" class="mapdetail-header">
      CITY details
      <i class="fa" [ngClass]="isCityDetailsVisible ? 'fa-angle-down' : 'fa-angle-up'" style="margin-left: auto"></i>
    </h4>

    <ul *ngIf="isCityDetailsVisible">
      <ng-container *ngIf="cityData; else elseBlock">
        <ng-container *ngFor="let property of cityData | keyvalue: cityDetailsSort">
          <ng-container *ngIf="property.key == 'City Name'; else normalKeyValue">
            <li (click)="navigateToCityNameWiki()">
              {{ property.key }}:
              <span class="pointer pointer-cursor-link pl-2">{{ property.value }}
              </span>
            </li>
          </ng-container>
          <ng-template #normalKeyValue>
            <li>{{ property.key }}: {{ property.value }}</li>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-template #elseBlock>
        <li>No city selected</li>
      </ng-template>
    </ul>
  </div>
</div>
<div class="side-menu-wrapper-city-map" [hidden]="!isDisplayCityMap"
  style="position: absolute; z-index: 222222; height: 100%">
  <div class="main-inner-wrapper">
    <div class="main-toggler" style="position: absolute; z-index: 2"
      [style.marginLeft]="isMenu2Open ? '400px' : isMenu1Open ? '200px' : '0px'"
      (click)="toggleMenu(isMenu1Open ? 'close' : 'menu1', false)">
      <button class="btnIcon">
        <img class="img-class" [src]="
            isMenu1Open
              ? 'assets/images/left-arrow-7288.svg'
              : 'assets/images/arrow-right-2817.svg'
          " />
      </button>
    </div>
    <div class="side-menu" [class.open]="isMenu1Open" [class.hidden]="!isMenu1Open">
      <button *ngIf="!isMenu2Open" class="btn-first-close" (click)="isMenu1Open = false">
        <i class="fa fa-close" style="font-size: 16px"></i>
      </button>
      <div class="menu-option" (click)="toggleMenu('menu2', true, 'createContent')">
        <button class="btn-option btn btn-dark btn-sm player-list-btn" style="padding-top: 0px">
          Create content
        </button>
      </div>
      <div class="menu-option" (click)="toggleMenu('menu2', true, 'playersContent')">
        <button class="btn-option btn btn-dark btn-sm player-list-btn" style="padding-top: 0px">
          Players content
        </button>
      </div>
    </div>

    <div *ngIf="isMenu2Open" [ngClass]="{ 'side-menu': isMenu2Open, 'margin-200': isMenu1Open }">
      <button class="btn-first-close" (click)="toggleMenu('menu2', false)">
        <i class="fa fa-close"></i>
      </button>
      <div class="content-div" [ngSwitch]="optionText">
        <div class="saved-content-div" *ngSwitchCase="'Saved'">
        </div>
        <div class="history-main-wrapper" *ngSwitchCase="'playerHistory'">
          <h6 class="text-center menu-option btn-option" style="color: white">
            {{ "Player History" }}
          </h6>
          <div class="history-inner-wrapper p-2">
            <div class="history-records-wrapper border border-secondary mb-1 myStylePlayer"
              *ngFor="let record of historyCityRecords; let i = index">
              <div class="d-flex align-items-start justify-content-start flex-column mb-2">
                <div class="story-wrapper d-flex flex-wrap">
                  <p class="m-0">{{ record.details }}</p>
                </div>
                <div class="button-wrapper align-self-end justify-content-end">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                    (click)="editDetail(record, true)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M10.5137 0.806497C11.5869 -0.268258 13.3274 -0.268916 14.4013 0.805026L16.8932 3.29688C17.958 4.36166 17.969 6.08542 16.918 7.16379L7.68486 16.637C6.97933 17.3609 6.01167 17.7691 5.00124 17.7691L2.24909 17.7689C0.969844 17.7689 -0.0517699 16.7025 0.00203171 15.4234L0.120186 12.6144C0.159684 11.6754 0.549963 10.7854 1.2138 10.1205L10.5137 0.806497ZM13.3415 1.86649C12.8533 1.37833 12.0622 1.37863 11.5744 1.86716L9.9113 3.53276L14.1911 7.81255L15.8446 6.11603C16.3224 5.62586 16.3173 4.84233 15.8333 4.35834L13.3415 1.86649ZM2.27446 11.1812L8.85145 4.59422L13.144 8.88682L6.61148 15.5893C6.18816 16.0236 5.60756 16.2685 5.0013 16.2685L2.24916 16.2684C1.82274 16.2684 1.4822 15.9129 1.50014 15.4865L1.61829 12.6775C1.64199 12.1141 1.87616 11.5801 2.27446 11.1812ZM17.5148 17.6958C17.9289 17.6958 18.2645 17.3598 18.2645 16.9455C18.2645 16.5311 17.9289 16.1952 17.5148 16.1952H11.3931C10.9791 16.1952 10.6434 16.5311 10.6434 16.9455C10.6434 17.3598 10.9791 17.6958 11.3931 17.6958H17.5148Z"
                      fill="#fff" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-wrapper-create-content mt-5" *ngSwitchCase="'createContent'">
          <div class="add-contanier mt-2" *ngIf="openContentCreationCity">
            <img class="secondImg" src="assets/images/cross-icon.svg" />
          </div>
          <div class="add-contanier mt-2" *ngIf="!openContentCreationCity"
            (click)="openContentCreationCity = !openContentCreationCity">
            <img src="assets/images/plus-icon.svg" />
          </div>
          <div class="content-list-wrapper">
            <ng--container *ngFor="let content of cityContentCreatorData; let i = index">
              <div class="content-inner">
                <h5>{{ content.content_title }}</h5>
                <div class="d-flex align-items-center justify-content-center">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                    (click)="editCityContent(content)" class="mr-2 pointer">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M10.5137 0.806497C11.5869 -0.268258 13.3274 -0.268916 14.4013 0.805026L16.8932 3.29688C17.958 4.36166 17.969 6.08542 16.918 7.16379L7.68486 16.637C6.97933 17.3609 6.01167 17.7691 5.00124 17.7691L2.24909 17.7689C0.969844 17.7689 -0.0517699 16.7025 0.00203171 15.4234L0.120186 12.6144C0.159684 11.6754 0.549963 10.7854 1.2138 10.1205L10.5137 0.806497ZM13.3415 1.86649C12.8533 1.37833 12.0622 1.37863 11.5744 1.86716L9.9113 3.53276L14.1911 7.81255L15.8446 6.11603C16.3224 5.62586 16.3173 4.84233 15.8333 4.35834L13.3415 1.86649ZM2.27446 11.1812L8.85145 4.59422L13.144 8.88682L6.61148 15.5893C6.18816 16.0236 5.60756 16.2685 5.0013 16.2685L2.24916 16.2684C1.82274 16.2684 1.4822 15.9129 1.50014 15.4865L1.61829 12.6775C1.64199 12.1141 1.87616 11.5801 2.27446 11.1812ZM17.5148 17.6958C17.9289 17.6958 18.2645 17.3598 18.2645 16.9455C18.2645 16.5311 17.9289 16.1952 17.5148 16.1952H11.3931C10.9791 16.1952 10.6434 16.5311 10.6434 16.9455C10.6434 17.3598 10.9791 17.6958 11.3931 17.6958H17.5148Z"
                      fill="#fff" />
                  </svg>
                  <button type="button " class="delete-btn" (click)="deleteCityContentRecord(content.id)">
                    <i class="fa fa-trash"> </i>
                  </button>
                </div>
              </div>
            </ng--container>
          </div>
        </div>
        <div class="main-wrapper-create-content mt-5" *ngSwitchCase="'playersContent'">
          <div class="content-list-wrapper">
            <ng--container *ngFor="let content of playerCreatorData; let i = index">
              <div class="content-inner">
                <h5>{{ content.modulename }}</h5>
              </div>
            </ng--container>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-around flex-column" *ngSwitchCase="'favorites'">
          <div
            class="saved-item-div d-flex align-items-center justify-content-around border border-dark p-1 secondPanel favroite-main-div"
            *ngFor="let favroiteItem of cityFavroiteRecords; let i = index">
            <ng-container *ngIf="cityFavroiteRecords">
              <div
                class="inner-content-div mr-2 p-1 border border-light d-flex align-items-start justify-content-start flex-column">
                <p class="m-0">
                  {{ i + 1 }}. {{ " " + favroiteItem.category }}
                </p>
                <p class="m-0">Color: {{ " " + favroiteItem.color }}</p>
                <p class="m-0">Details:{{ " " + favroiteItem.details }}</p>
              </div>
            </ng-container>
          </div>
        </div>
        <div style="color: #fff" *ngSwitchDefaults>Render this</div>
      </div>
    </div>
  </div>
</div>
<div [ngStyle]="{
    width: isDisplayCityMap ? '100vw' : '0vw',
    height: isDisplayCityMap ? '100vh' : '0vh',
    visibility: isDisplayCityMap ? 'visible' : 'hidden',
  }">
  <!-- Header -->
  <div class="map-top-header">
    <div class="d-flex align-items-center justify-content-between g-20">
      <div class="dmenu">
        <img src="assets/icons/down-arrow-white.svg" alt="" (click)="openSideDropdownOption()" />
        <ul class="dropdown-options" *ngIf="showDropdown">
          <li (click)="setSelectOption('Favourite')">Favorites</li>
          <li (click)="setSelectOption('Timeline General')">
            Timeline General
          </li>
        </ul>
      </div>
      <div class="map-search-box">
        <input class="map-search-input" type="text" placeholder="Future enhancement.." />
        <button class="map-search-btn">
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="13.9908" cy="14.2886" r="8.16459" stroke="#002B4E" stroke-width="2.72153" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M20.1134 20.4121L26.2368 26.5356" stroke="#002B4E" stroke-width="2.72153" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Map Container -->
  <div id="map1" class="map-container"></div>

  <!-- Footer (Add if needed) -->
  <div class="map-footer">
    <app-footer></app-footer>
  </div>

  <!-- Footer content goes here -->
</div>
<!-- no site footer on the play screen: the map uses the whole window -->

<!-- Resource Hover Tooltip Card -->
<div class="resource-hover-card" *ngIf="hoveredResource" [ngStyle]="tooltipStyle">
  <div class="resource-card-arrow"></div>
  <h4 class="resource-card-title">{{ hoveredResource.name }}</h4>
  <p class="resource-card-desc" *ngIf="hoveredResource.description">
    {{ hoveredResource.description }}
  </p>
  <div class="resource-card-metrics" *ngIf="hoveredResource.production !== undefined || hoveredResource.economy !== undefined || hoveredResource.rarity !== undefined || hoveredResource.processing !== undefined">
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.production || 0 }}</div>
      <div class="metric-label">Production</div>
    </div>
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.economy || 0 }}</div>
      <div class="metric-label">Economy</div>
    </div>
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.rarity || 0 }}</div>
      <div class="metric-label">Rarity</div>
    </div>
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.processing || 0 }}</div>
      <div class="metric-label">Processing</div>
    </div>
  </div>
</div>